import { mapState } from 'vuex'
import moment from 'moment'
import { capacityControlModes } from '@/config'
import { colonHourToMs } from '@/lib/helpers/HoursFormatter'
import { getTextValue } from '@/lib/helpers/LocalizedText'
import { isBase64 } from '@/lib/helpers/File'

export default {
  computed: {
    ...mapState({
      activities: state => state.activities,
      configuration: state => state.service.configuration,
      extendedActivity: state => state.activities.extendedActivity,
    }),

    maximumCapacity () {
      return this.reservationMethod ? this.reservationMethod.maximumCapacityPerSlot : null
    },
  
    acceptRoomCharge () {
      return this.configuration.acceptRoomCharge
    },

    acceptCardPayments () {
      return this.configuration.acceptCardPayments
    },

    paymentMethodsAsServices () {
      return this.extendedActivity.paymentMethodList
    },    

    allPaymentMethods () {
      if (!this.extendedActivity) return []
      let paymentMethodGenerated = []

      if (this.extendedActivity.activity.enabledWebappPaymentMethods.roomCharge) {
        paymentMethodGenerated.push({
          id: 'roomCharge',
          image: 'mdi-bed-king-outline',
          typeImage: 'ICON',
          name: this.$t('activity_reservation.room_charge'),
          enabled: this.acceptRoomCharge, 
        })
      }

      this.paymentMethodsAsServices.map((paymentMethod) => {
        let typeImage = 'ICON'
        let image = paymentMethod.image

        if (!image) {
          image = 'mdi-credit-card'
        } else if (image.includes('https') || isBase64(image)) {
          typeImage = 'IMAGE'
        }

        paymentMethodGenerated.push({
          ...paymentMethod,
          image,
          typeImage,
          name: getTextValue(paymentMethod.name),
          enabled: this.acceptCardPayments, 
        })
      })

      return paymentMethodGenerated
    },
  },
  methods: {
    getCapacityStatus ({
      slot = this.slot,
      currentAttendees = this.people,
      max = this.maximumCapacity,
      date = this.date,
      over = false, // Returns true if capacity is over...
      reached = false, // ... or reached
    }) {
      const ms = colonHourToMs(slot)
      if (typeof ms === 'number' && max && (over || reached)) {
        const slotCapacity = this.activities.capacityPerSlot
          .find((slotCapacity) => (
            slotCapacity.reservationMethod === this.reservationMethod.type &&
            slotCapacity.date === date &&
            slotCapacity.hour === ms
          ))
        const currentCapacity = slotCapacity ? slotCapacity.currentCapacity : 0
        if (this.reservationMethod.capacityControlMode === capacityControlModes.RESERVATIONS) currentAttendees = 1
        return over
          ? currentAttendees + currentCapacity > max
          : reached
            ? currentAttendees + currentCapacity >= max
            : false
      }
      return false
    },
    getSlotCapacity ({
      slot = this.slot,
      date = this.date,
      save = true,
      activityId = this.$route.params.activityId,
    } = {}) {
      const requestedMoment = this.getReservationRequestedMoment({
        requestedDate: date,
        requestedTime: colonHourToMs(slot),
      })
      if (!requestedMoment.isValid()) return new Promise((resolve, reject) => resolve(null))
      return this.$store.dispatch('activities/listCapacityPerSlot', {
        id: activityId,
        since: requestedMoment.toISOString(),
        until: requestedMoment.add(1).toISOString(),
        save,
      }).catch(() => {})
    },
    getReservationRequestedMoment (reservation) {
      return moment(reservation.requestedDate, 'YYYY-MM-DD').add({
        minute: moment().utcOffset(),
        millisecond: reservation.requestedTime,
      })
    },
  },
}
